<template>
  <div class="shadow-xs rounded">
    <div class="py-4 bg-white px-6 pt-4 pb-6 rounded shadow-lg">
      <form @submit.prevent="doApplyFilters">
        <h5 class="text-base mb-4 flex items-baseline">
          <span>{{ totalSelectedFilters }} active filters</span>
          <button
            type="button"
            class="px-3 py-2 rounded transition-color transition-faster text-sm ml-2 bg-transparent text-gray-900 focus:bg-gray-400 focus:outline-none"
            @click="doResetFilters"
          >
            Reset
          </button>
        </h5>

        <div class="flex flex-col">
          <div v-if="statuses.length > 0">
            <h5 class="text-xs font-normal text-gray-600 mb-2 flex items-baseline">Status</h5>
            <ul class="flex flex-wrap -m-1">
              <li v-for="option in statuses" :key="option.name" class="inline-flex p-1">
                <label class="relative select-none">
                  <input
                    v-model="selectedStatuses"
                    :type="inputType"
                    name="statuses"
                    :value="option.value"
                    class="opacity-0 absolute field"
                  />
                  <div
                    :class="[
                      ...(changedStatuses.indexOf(option.value) !== -1
                        ? ['bg-green-300', 'field-checked:bg-green-500']
                        : ['bg-gray-300', 'field-checked:bg-blue-500']),
                    ]"
                    class="flex items-baseline px-4 py-2 rounded-full"
                  >
                    <div class="flex-1 truncate text-sm field-checked:text-white">
                      {{ option.name }}
                    </div>
                    <div
                      :class="[
                        ...(changedStatuses.indexOf(option.value) !== -1
                          ? ['text-green-600', 'field-checked:text-green-200']
                          : ['text-gray-600', 'field-checked:text-blue-200']),
                      ]"
                      class="flex-none ml-2 text-xs"
                    >
                      {{ option.relatedCount }}
                    </div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
          <!-- Status Filter -->

          <template v-if="assignees.length > 0">
            <hr class="my-6 -mx-6 border-gray-200" />

            <div>
              <h5 class="text-xs font-normal text-gray-600 mb-2 flex items-baseline">Assignee</h5>
              <ul class="flex flex-wrap -m-1">
                <li v-for="option in assignees" :key="option.name" class="inline-flex p-1">
                  <label class="relative select-none">
                    <input
                      v-model="selectedAssignees"
                      :type="inputType"
                      name="statuses"
                      :value="option.value"
                      class="opacity-0 absolute field"
                    />
                    <div
                      :class="[
                        ...(changedAssignees.indexOf(option.value) !== -1
                          ? ['bg-green-300', 'field-checked:bg-green-500']
                          : ['bg-gray-300', 'field-checked:bg-blue-500']),
                      ]"
                      class="flex items-baseline px-4 py-2 rounded-full"
                    >
                      <div class="flex-1 truncate text-sm field-checked:text-white">
                        {{ option.name }}
                      </div>
                      <div
                        :class="[
                          ...(changedAssignees.indexOf(option.value) !== -1
                            ? ['text-green-600', 'field-checked:text-green-200']
                            : ['text-gray-600', 'field-checked:text-blue-200']),
                        ]"
                        class="flex-none ml-2 text-xs"
                      >
                        {{ option.relatedCount }}
                      </div>
                    </div>
                  </label>
                </li>
              </ul>
            </div>
            <!-- Assignee Filter -->
          </template>

          <template>
            <hr class="my-6 -mx-6 border-gray-200" />

            <div>
              <h5 class="text-xs font-normal text-gray-600 mb-2 flex items-baseline">Due</h5>
              <div>
                <span class="text-gray-700 text-sm">From</span>
                <input
                  type="date"
                  v-model="dueSince"
                  class="px-4 py-2 leading-5 text-sm border rounded mx-2 hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50"
                />
                <span class="text-gray-700 text-sm">To</span>
                <input
                  type="date"
                  v-model="dueBefore"
                  class="px-4 py-2 leading-5 text-sm border rounded ml-2 hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50"
                />
              </div>
            </div>
          </template>

          <template>
            <hr class="my-6 -mx-6 border-gray-200" />

            <div>
              <h5 class="text-xs font-normal text-gray-600 mb-2 flex items-baseline">Created</h5>
              <div>
                <span class="text-gray-700 text-sm">From</span>
                <input
                  type="date"
                  v-model="createdSince"
                  class="px-4 py-2 leading-5 text-sm border rounded mx-2 hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50"
                />
                <span class="text-gray-700 text-sm">To</span>
                <input
                  type="date"
                  v-model="createdBefore"
                  class="px-4 py-2 leading-5 text-sm border rounded ml-2 hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50"
                />
              </div>
            </div>
          </template>

          <template v-if="!singleMode">
            <hr class="my-6 -mx-6 border-gray-200" />

            <div class="flex">
              <button
                class="px-3 py-2 rounded transition-color transition-faster text-sm bg-blue-500 text-white focus:bg-blue-700 focus:outline-none"
              >
                Apply Filter
              </button>
              <button
                type="button"
                class="px-3 py-2 rounded transition-color transition-faster text-sm ml-2 bg-transparent text-gray-900 focus:bg-gray-400 focus:outline-none"
                @click="doCancel"
              >
                Cancel
              </button>
            </div>
          </template>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { differenceWith } from 'lodash-es';

export default {
  props: {
    filters: {
      type: Object,
      default: () => undefined,
    },
  },
  data() {
    return {
      selectedStatuses: [],
      selectedAssignees: [],
      dueSince: '',
      dueBefore: '',
      createdSince: '',
      createdBefore: '',
      showFilters: false,
      changedStatuses: [],
      changedAssignees: [],
      singleMode: false,
    };
  },

  computed: {
    inputType() {
      return this.singleMode ? 'radio' : 'checkbox';
    },
    statuses() {
      return (this.filters || {}).statuses || [];
    },
    assignees() {
      return (this.filters || {}).assignees || [];
    },
    totalSelectedFilters() {
      if (this.singleMode) return 0;

      return [
        this.selectedStatuses.length > 0,
        this.selectedAssignees.length > 0,
        this.dueSince.length > 0 || this.dueBefore.length > 0,
        this.createdSince.length > 0 || this.createdBefore.length > 0,
      ].reduce((acc, cur) => (cur === true ? acc + 1 : acc), 0);
    },
  },

  watch: {
    singleMode(isSingle) {
      this.selectedStatuses = isSingle ? null : [];
      this.selectedAssignees = isSingle ? null : [];
    },
    selectedStatuses(value) {
      if (this.singleMode && value) {
        this.selectedAssignees = '';
        this.doApplyFilters();
      }
    },
    selectedAssignees(value) {
      if (this.singleMode && value) {
        this.selectedStatuses = '';
        this.doApplyFilters();
      }
    },
    filters: {
      handler(newFilters, oldFilters) {
        if (oldFilters === undefined) return;

        const { statuses: newStatuses = [], assignees: newAssignees = [] } = newFilters;

        const { statuses: oldStatuses = [], assignees: oldAssignees = [] } = oldFilters;

        const statusesChanged = differenceWith(newStatuses, oldStatuses, (a, b) => {
          const { name: newName, relatedCount: newRelatedCount } = a;
          const { name: oldName, relatedCount: oldRelatedCount } = b;

          if (newName !== oldName) return false;

          return newRelatedCount <= oldRelatedCount;
        });

        statusesChanged.forEach((changed) => {
          const index = this.changedStatuses.indexOf(changed.value);

          if (index === -1) {
            this.changedStatuses.push(changed.value);
          }
        });

        const assigneesChanged = differenceWith(newAssignees, oldAssignees, (a, b) => {
          const { name: newName, relatedCount: newRelatedCount } = a;
          const { name: oldName, relatedCount: oldRelatedCount } = b;

          if (newName !== oldName) return false;

          return newRelatedCount <= oldRelatedCount;
        });

        assigneesChanged.forEach((changed) => {
          const index = this.changedAssignees.indexOf(changed.value);

          if (index === -1) {
            this.changedAssignees.push(changed.value);
          }
        });
      },
      deep: true,
    },
  },

  created() {
    this.setFromQuery();
  },

  methods: {
    setFromQuery() {
      const {
        filter: {
          status = '',
          assignee_id: assigneeId = '',
          due_since: dueSince = '',
          due_before: dueBefore = '',
          created_since: createdSince = '',
          created_before: createdBefore = '',
        } = {},
      } = this.$route.query;

      if (typeof status === 'string') {
        this.selectedStatuses = status.length > 0 ? status.split(',') : [];
      } else {
        this.selectedStatuses = [status];
      }

      if (typeof assigneeId === 'string') {
        this.selectedAssignees = assigneeId.length > 0 ? assigneeId.split(',') : [];
      } else {
        this.selectedAssignees = [assigneeId];
      }

      this.dueSince = dueSince;
      this.dueBefore = dueBefore;
      this.createdSince = createdSince;
      this.createdBefore = createdBefore;
    },

    doCancel() {
      this.$emit('filters:cancel');
    },

    doApplyFilters() {
      const { path, params, query } = this.$route;

      const filter = {};
      const statuses = Array.isArray(this.selectedStatuses)
        ? this.selectedStatuses.toString()
        : this.selectedStatuses;
      const assignees = Array.isArray(this.selectedAssignees)
        ? this.selectedAssignees.toString()
        : this.selectedAssignees;

      if (statuses) filter.status = statuses;
      if (assignees) filter.assignee_id = assignees;
      if (this.dueSince) filter.due_since = this.dueSince;
      if (this.dueBefore) filter.due_before = this.dueBefore;
      if (this.createdSince) filter.created_since = this.createdSince;
      if (this.createdBefore) filter.created_before = this.createdBefore;

      const queryPush = {
        ...query,
        filter,
        page: 1,
      };

      if (JSON.stringify(query) === JSON.stringify(queryPush)) {
        queryPush.t = Date.now();
      }

      this.$router.push({
        path,
        params,
        query: queryPush,
      });

      this.syncChanged();

      this.$emit('filters:applied');
    },

    syncChanged() {
      this.changedStatuses = [
        ...this.changedStatuses.filter((id) => {
          if (Array.isArray(this.selectedStatuses)) {
            return this.selectedStatuses.indexOf(id) === -1;
          }
          return this.selectedStatuses !== id;
        }),
      ];

      this.changedAssignees = [
        ...this.changedAssignees.filter((id) => {
          if (Array.isArray(this.selectedAssignees)) {
            return this.selectedAssignees.indexOf(id) === -1;
          }
          return this.selectedAssignees !== id;
        }),
      ];
    },

    doResetFilters() {
      this.selectedStatuses = this.singleMode ? null : [];
      this.selectedAssignees = this.singleMode ? null : [];
      this.dueSince = '';
      this.dueBefore = '';
      this.createdSince = '';
      this.createdBefore = '';
    },
  },
};
</script>
